// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._16jlidpf{flex-grow:0}\n._1e0c1txw{display:flex}\n._1o9zidpf{flex-shrink:0}\n._1wpz1h6o{align-self:center}\n._syaz1kw7{color:inherit}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}", ""]);
// Exports
module.exports = exports;
